export const fontFamilyHeadings = ['Playfair Display', 'serif'].join(',')

export const fontFamilyPrimary = ['Playfair Display', 'serif'].join(',')

export const fontFamilyPrimary2 = ['Oxygen Mono', 'monospace'].join(',')
